module.exports = __webpack_public_path__ + "static/media/inventory-management.8196da24.png";